import sortBy from 'lodash/sortBy';
import toInteger from 'lodash/toInteger';
import uniqBy from 'lodash/uniqBy';
import filter from 'lodash/filter';

function filterByZones(prices, listOfZones) {
  return prices.reduce(function(acc, curr) {
    if (listOfZones.indexOf(parseInt(curr.zone_no, 10)) !== -1) {
      acc.push(curr.price);
    }
    return acc;
  }, []);
}

/**
 * Returns a sorted list of unique prices,
 * Data in the format:
 * [{
 *     isDisabled: false,
 *     priceData: {...}
 * }]
 */
function sortedUniquePrices(prices) {
  let newPrices = filter(prices, price => {
    return parseFloat(price.price) > 0;
  });

  newPrices = sortBy(newPrices, x => parseFloat(x.price)).reverse();
  newPrices = uniqBy(newPrices, 'price');

  return newPrices.map(item => {
    return {
      isDisabled: false,
      priceData: item
    };
  });
}

/**
 * Returns a sorted list of unique zone groups,
 * Data in the format:
 * [{
 *     isDisabled: false,
 *     priceData: {...}
 * }]
 */
function sortedUniqueZoneGroups(prices) {
  let newPrices = filter(prices, price => {
    return parseFloat(price.price) > 0;
  });

  newPrices = sortBy(newPrices, x => parseFloat(x.price)).reverse();
  newPrices = uniqBy(newPrices, 'zone_group_no');

  return newPrices.map(item => {
    return {
      isDisabled: false,
      priceData: item
    };
  });
}

/**
 * When we have multiple levels or screens it's useful to
 * disable price options that don't currently apply.
 * Data in the format:
 * [{
 *     isDisabled: false,
 *     priceData: {...}
 * }, {
 *     isDisabled: true,
 *     priceData: {...}
 * },]
 */
function activePricesByZones(prices, listOfZones) {
  let filteredPrices = filterByZones(prices, listOfZones.map(toInteger));
  let sortedPrices = sortedUniqueZoneGroups(prices);
  let newPrices = sortedPrices.map(function(item) {
    item.isDisabled =
      filteredPrices.indexOf(item.priceData.price) === -1 ? true : false;
    return item;
  });
  return newPrices;
}

export default function getAvailablePrices(prices, listOfZones) {
  if (listOfZones) {
    return activePricesByZones(prices, listOfZones);
  } else {
    return sortedUniqueZoneGroups(prices);
  }
}



// WEBPACK FOOTER //
// ./src/javascripts/lib/pricing/getAvailablePrices.js